import { MouseEvent, Children, FC, PropsWithChildren, cloneElement, isValidElement } from 'react';
import { useMenuDropdown } from '../MenuProvider';

const MenuTrigger: FC<PropsWithChildren<unknown>> = ({ children }) => {
    const ctx = useMenuDropdown();

    const handleClick = (event: MouseEvent<HTMLElement>) => {
        ctx.setVisibility(true, event.currentTarget);
    };

    if (isValidElement(children)) {
        return cloneElement(Children.only(children), {
            ...children.props,
            onClick: handleClick,
        });
    }

    return null;
};

export default MenuTrigger;
